import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { destroyLenis, initLenis, scrollToId } from "./lib/lenis";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Method } from "./components/Method";
import { Results } from "./components/Results";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { services } from "./data";

const Home = () => {
  const [selectedService, setSelectedService] = useState(services[0].title);
  const pickService = (title) => {
    setSelectedService(title);
    scrollToId("contact");
  };

  return (
    <div className="site-shell">
      <Nav />
      <main id="top">
        <Hero />
        <Marquee />
        <Services onSelect={pickService} />
        <Method />
        <Results />
        <Contact selectedService={selectedService} setSelectedService={setSelectedService} />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="App">
      <Toaster theme="dark" position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
